import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import BgBox from './BgBox'
import { makeTxtOverFLow } from '../utils/format'

function CountCard({ imgPath, title, count }) {
    return (
        <Box height={100} width={210} mt={1} position={"relative"}>
            <BgBox px={1} py={0}>
                <Stack alignItems={"center"}>
                    <Stack direction={'row'} alignItems={"center"} gap={2}>
                        <img src={imgPath} alt={imgPath} style={{ position: "absolute", top: -5, left: -5, height: 50 }} />
                        <Typography sx={{ fontWeight: "500", fontSize: 25 }}>{makeTxtOverFLow(count.toString(), 7)}</Typography>
                    </Stack>
                    <Typography sx={{ color: "secondary.main", fontSize: 13 }}>{title}</Typography>
                </Stack>
            </BgBox>
        </Box>
    )
}

export default CountCard